<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>

	</div>
</template>

<script>
import SCREEN_SIZE from '@/const/screen';
import geoMapYN from '@/const/geoMap/geoMapYN';
import geoMapYN_child from '@/const/geoMap/geoMapYN_child';

export default {
	data () {
		return {};
	},
	created () {
		this.$echarts.registerMap('geoMapYN', geoMapYN);
		this.$echarts.registerMap('geoMapYN_child', geoMapYN_child);
	},
	mounted () {
		/**
		 * 监听页面路由
		 */

		document.title = this.$router.history.current.meta.title;
		// 初始化页面尺寸
		const sourceSize = SCREEN_SIZE[this.$router.history.current.meta.title];
		this.$util.initPageSize(sourceSize.width, sourceSize.height, true);
		window.onresize = ()=>{
			this.$util.initPageSize(sourceSize.width, sourceSize.height, true);
		}
	}
};
</script>
